var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAvatarDefault(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 203,
    height: 203,
    viewBox: "0 0 203 203",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#d8d8d8;}.b{fill:#fbfbfb;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.24 0.293)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 101.5,
    cy: 101.5,
    r: 101.5,
    transform: "translate(0.24 -0.293)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(64.206 64.788)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(15.805)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M132.62,0a21.829,21.829,0,1,0,21.829,21.829A21.887,21.887,0,0,0,132.62,0Z",
    transform: "translate(-110.791)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 45.219)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M99.26,263.723a20.348,20.348,0,0,0-2.192-4A27.133,27.133,0,0,0,78.29,247.9a4.018,4.018,0,0,0-2.764.667,23.268,23.268,0,0,1-27.453,0,3.577,3.577,0,0,0-2.764-.667,26.936,26.936,0,0,0-18.778,11.82,23.463,23.463,0,0,0-2.192,4,2.027,2.027,0,0,0,.1,1.811,38.024,38.024,0,0,0,2.574,3.813,36.224,36.224,0,0,0,4.385,4.957,57.116,57.116,0,0,0,4.385,3.813,43.469,43.469,0,0,0,51.855,0,41.907,41.907,0,0,0,4.385-3.813,44.013,44.013,0,0,0,4.385-4.957,33.421,33.421,0,0,0,2.574-3.813A1.627,1.627,0,0,0,99.26,263.723Z",
    transform: "translate(-24.165 -247.841)"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatarDefault);
export default __webpack_public_path__ + "static/media/avatar_default.1b1c2e019dc6791984a1e5926e9a09ec.svg";
export { ForwardRef as ReactComponent };